'use client';

import { useEffect } from 'react';

/**
 * The Packeta widget key for the pick-point pickers. Core `CartScriptsHead` keeps it in a `const`
 * of an inline script, but the pickers (core `CartShipmentProvider`, our `PickupPoint`) read
 * `window.packetaApiKey` – never set, so the widget opened without a key. The key is public (core
 * prints it into the page); the cart page hands it over here.
 */
export function PacketaKey({ apiKey }: { apiKey: string | null }) {
  useEffect(() => {
    if (apiKey) window.packetaApiKey = apiKey;
  }, [apiKey]);
  return null;
}
